import { render, staticRenderFns } from "./ConfigureModalityForm.vue?vue&type=template&id=1a0a93a6"
import script from "./ConfigureModalityForm.vue?vue&type=script&lang=js"
export * from "./ConfigureModalityForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigureModalityForm.vue?vue&type=style&index=0&id=1a0a93a6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports